import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
  border-radius: 16px;
  border: 1px;
  margin-top: 1rem;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
  h3 {
    color: #333333;
    font-family: "Inter";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.125rem;
    letter-spacing: 0px;
    text-align: left;
    margin-bottom: 1rem;
    padding-left: 2rem;
    padding-top: 2rem;
  }
`;

export const ContainerCards = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: left;
  padding: 0 2rem;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  position: relative;
  min-height: 110px;
  padding: 0 48px 24px;

  .rec-carousel-wrapper {
    width: 100%;
  }

  .produtos-interesse-pagination {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    align-items: center;
  }

  .produtos-interesse-pagination-item {
    background-color: #e5e5e5;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    margin-right: 8px;
    height: 5px;
    width: 5px;
    padding: 0;
    transition: background-color 0.3s ease, height 0.3s ease, width 0.3s ease;

    &:hover,
    &.active {
      background-color: #2d5bff;
      height: 8px;
      width: 8px;
    }
  }

  .produtos-interesse-arrow-slot {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    &.prev {
      left: 0;
    }

    &.next {
      right: 0;
    }
  }

  .produtos-interesse-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: none;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    height: 40px !important;
    width: 40px !important;
    min-width: 40px !important;
    max-width: 40px !important;
    padding: 0;

    &:hover:not(:disabled) {
      background-color: #f5f5f5;
    }

    &:disabled {
      cursor: default;
      pointer-events: none;
    }
  }
`;

export const EmptyState = styled.p`
  display: flex;
  justify-content: center;
  width: 100%;
  font-family: "Inter";
  color: #686775;
  font-weight: bold;
  font-size: 14px;
  padding: 24px 0 32px;
`;

export const ContainerBottomSpacer = styled.div`
  min-height: 2rem;
`;

export const DadosCompContainer = styled.div`
  width: 100%;
  height: 2.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
  background-color: #ffffff;
  border-top: solid 2px #f5f5f5;
  margin-top: 2.875rem;

  button {
    border: none;
    color: #2d5bff;
    font-family: "Inter";
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.125rem;
    letter-spacing: 0px;
    text-align: left;
    background-color: transparent;
    &:hover {
      cursor: pointer;
      transition: transform 250ms;
      transform: scale(1.02);
      text-shadow: #2d5bff 1px 0px 80px;
    }
  }
`;
